export default "__VITE_ASSET__2ldIdUOo__"